import React from "react";
import { useTranslation } from "react-i18next";
import "./FormField.css";

const FormField = ({
  name,
  label,
  required = false,
  hint,
  error,
  touched,
  children,
  className = "",
  labelRight,
}) => {
  const { t } = useTranslation();
  const showError = Boolean(touched && error);

  return (
    <div className={`ff-field ${showError ? "ff-field--error" : ""} ${className}`}>
      {(label || labelRight) && (
        <div className="ff-field__label-row">
          {label && (
            <label htmlFor={name} className="ff-field__label">
              {label}
              {required && <span className="ff-field__required" aria-hidden="true"> *</span>}
            </label>
          )}
          {labelRight && <div className="ff-field__label-right">{labelRight}</div>}
        </div>
      )}
      <div className="ff-field__control">{children}</div>
      {hint && !showError && <p className="ff-field__hint">{hint}</p>}
      {showError && (
        <p className="ff-field__error" role="alert">
          {t(error)}
        </p>
      )}
    </div>
  );
};

export default FormField;
